import { Form, Formik } from 'formik';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import lodash from 'lodash';
import { toastr } from 'react-redux-toastr';
import { useHistory, useParams } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';
import * as Yup from 'yup';
import formBuilder from 'ui-blocks/form-builder';
import { Col } from 'reactstrap';
import {
   TextInput,
   Checkbox,
   SelectInput,
   AdvertiserMultiSelectSA,
   CampaignMultiSelectSA,
   PublisherMultiSelectSA,
   ContractMultiSelectSA, SourceSelectPillsSA,
} from 'ui-blocks/form-elements';
import { ButtonsSubmitExport } from 'ui';
import config from './formConfig';
import FieldItem from './FieldItem';

import FieldArrayItem from './FieldArrayItem';
import NumberInput from "../../../../../ui-blocks/form-elements/input/NumberInput";

const formBuilderBag = formBuilder.build(config);
const { withComponentWrapper } = formBuilderBag;

const ruleTypeSelectOptions = [
   {
      label: 'Blacklist',
      value: 'advertiser_blacklist',
   },
];

const deviceTypeSelectOptions = [
   {
      label: 'All Devices',
      value: '',
   },
   {
      label: 'Mobile',
      value: 'mobile',
   },
   {
      label: 'Desktop',
      value: 'desktop',
   },
];

// const appAdminAccess = access.getAdminAccessByApp.sponsoredAds;

const getIdFromList = (objList = []) => {
   return lodash.isArray(objList) ? objList.map(({ id }) => id) : [];
};

const AdvertiserRulesForm = (props) => {
   const { mode } = useParams();
   const [modeLabel, setModeLabel] = useState();
   const history = useHistory();
   const userPartnerRoleList = useSelector(
      (state) => (state?.authReducer?.loggedInUserPartner?.roles || []),
      shallowEqual,
   );

   const [validationSchema, setValidationSchema] = useState(undefined);

   useEffect(() => {
      const innerValidationSchema = {
         name: Yup.string().required('Required!'),
         description: Yup.string().required('Required!'),
      };

      setValidationSchema(Yup.object().shape(innerValidationSchema));
   }, [userPartnerRoleList]);

   useEffect(() => {
      let newModeLabel;
      switch (mode) {
         case 'create':
            newModeLabel = 'Create';
            break;
         case 'edit':
            newModeLabel = 'Edit';
            break;
         default:
            newModeLabel = '??';
      }
      setModeLabel(newModeLabel);
   }, [mode]);

   return (
      <Formik
         initialValues={props.initialValues}
         validationSchema={validationSchema}
         validateOnChange={ false }
         validateOnBlur={ false }
         onSubmit={ (values, { setSubmitting, setErrors }) => {
            const {
               name,
               description,
               type,
               status,
               sources,
               publishers,
               cid,
               device,
               advertisers,
               campaigns,
               contracts,
               cpcFloor,
               ...restValues
            } = values;

            const payload = {
               ...restValues,
               name,
               description,
               type: type?.value,
               status: status ? 'Y' : 'N',
               sources: lodash.isArray(sources) ? sources.map((sourceItem) => sourceItem?.name) : [],
               publishers: getIdFromList(publishers),
               cid,
               device: device?.value || '',
               advertisers: getIdFromList(advertisers),
               campaigns: getIdFromList(campaigns),
               contracts: getIdFromList(contracts),
               cpcFloor: cpcFloor
            };

            const { create, edit } = config.settings.external.api.save;
            let apiCall = null;

            const isModeCreate = mode === 'create';
            if (isModeCreate) {
               apiCall = create;
            } else if (mode === 'edit') {
               apiCall = edit(props.initialValues?.id);
            }

            if (apiCall !== null && lodash.isFunction(apiCall)) {
               apiCall(payload).then((res) => {
                  const data = res?.data;
                  setSubmitting(true);
                  if (data?.response === 'success') {
                     if (isModeCreate) {
                        toastr.success('Advertiser Rule Created Successfully!');
                        history.replace(config.settings.internal.routing.basePath);
                     } else {
                        toastr.success('Update Success!');
                        history.replace(config.settings.internal.routing.basePath);
                     }
                  } else if (lodash.isPlainObject(data?.error)) {
                     setErrors(data.error);
                  } else {
                     toastr.error('Something went wrong. Please try again later.');
                  }
               });
            } else {
               console.error('No mode matching.');
            }
         } }
      >
         {
            (formik) => {
               return (

                  <Form className='container'>
                     <h4 className='mb-4'>
                        {modeLabel}
                        &nbsp;Advertiser Rule
                     </h4>
                     <FieldItem
                        label='Rule Name'
                        name='name'
                        component={TextInput}
                     />
                     <FieldItem
                        label='Rule Description'
                        name='description'
                        component={TextInput}
                     />
                     <FieldItem
                        label='Rule Type'
                        name='type'
                        isDisabled
                        component={SelectInput}
                        options={ruleTypeSelectOptions}
                     />
                     <FieldItem
                        label='Active Status'
                        name='status'
                        component={Checkbox}
                     />
                     <hr/>
                     <FieldArrayItem
                        label='Advertiser'
                        name='advertisers'
                        component={AdvertiserMultiSelectSA}
                     />
                     <FieldArrayItem
                        label='Campaign'
                        name='campaigns'
                        component={CampaignMultiSelectSA}
                     />
                     <hr/>
                     <FieldArrayItem
                        label='Source'
                        name='sources'
                        component={SourceSelectPillsSA}
                     />
                     <FieldArrayItem
                        label='Publisher'
                        name='publishers'
                        component={PublisherMultiSelectSA}
                     />
                     <FieldArrayItem
                        label='Contract'
                        name='contracts'
                        component={ContractMultiSelectSA}
                     />
                     <FieldItem
                        label='Device'
                        name='device'
                        component={SelectInput}
                        options={deviceTypeSelectOptions}
                     />
                     <FieldItem
                        label='CPC Floor'
                        name='cpcFloor'
                        component={NumberInput}
                     />
                     <Col xs={8}>
                        <div className='text-center mt-4'>
                           <ButtonsSubmitExport handleSubmit={formik.handleSubmit}/>
                        </div>
                     </Col>
                  </Form>
               );
            }
         }
      </Formik>
   );
};

AdvertiserRulesForm.propTypes = {
   initialValues: PropTypes.objectOf(PropTypes.any).isRequired,
   // reloadInitialValues: PropTypes.func.isRequired,
};

export const { path } = formBuilderBag;
export default withComponentWrapper(AdvertiserRulesForm);
